import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=238038a5&scoped=true&lang=html&"
import script from "./Unit.vue?vue&type=script&lang=ts&"
export * from "./Unit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238038a5",
  null
  
)

export default component.exports